import baseUrl from "../config/baseUrl";

const addUser = async ({
  token,
  userId,
  first_name,
  last_name,
  user_email,
  is_admin,
  role_id,
  password,
  password_confirmation,
}) => {
  const formData = new FormData();
  // Sent over HTTPS only; hashed by the server (never stored as plain text).
  if (password) {
    formData.append("password", password);
    formData.append("password_confirmation", password_confirmation);
  }
  formData.append("userId", userId);
  formData.append("first_name", first_name);
  formData.append("last_name", last_name);
  formData.append("email", user_email);
  formData.append("is_admin", is_admin);
  formData.append("role_id", role_id);

  try {
    const response = await fetch(`${baseUrl}/api/add-user`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default addUser;